import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../../../../app/directives/shared.module';
import { c_dialog_mp_settings_bulk_update_confirm_component } from './c_dialog_mp_settings_bulk_update_confirm_component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule
  ],
  declarations: [c_dialog_mp_settings_bulk_update_confirm_component],
  exports: [
    c_dialog_mp_settings_bulk_update_confirm_component
  ]
})
export class c_dialog_mp_settings_bulk_update_confirm_module { }
